import { useEffect, useReducer, useState } from "react";
import { Pagination } from "@sainsburys-tech/luna-pagination";
import { saveAs } from "file-saver";
import {
  initialState,
  reducer,
} from "../../../../Redux/Reducers/paginationReducer";
import * as CONSTANTS from "../../../../Constants";
import {
  errorToast,
  successToast,
} from "../../../../Service-Utils/toastMessage";
import { useGetApi } from "../../../../Redux/Hooks/useGetApi";
import { Container } from "@sainsburys-tech/luna-grid";
import { ButtonGroupPrimary, OutlinedButton } from "@sainsburys-tech/luna-button";
import CustomToast from "../../../SharedComponents/CustomToast";
import LoadingIndicator from "../../../Loading/index";
import { endpoints } from "../../../../ApiEndPoints/apiEndPoints";
import { IRequestParams } from "../../../../Interfaces/IRequestParams";
import EditableGridLuna from "../../../SharedComponents/EditableTable";
import { usePostApiRequest } from "../../../../Redux/Hooks/usePostApi";
import { FilterTypeForProduct } from "../../../../Types/filterTypeForProduct";
import { useSelector } from "react-redux";
import { filterPayloadType } from "../../../../Types/filterPayloadType";
import { storeFilter } from "../../../../Redux/Actions/filterActions";
import store from "../../../../Store/store";
import { decoratePayloadAndEndPoint } from "./decoratePayloadAndEndPointHelper";
import { storeSearchCount } from "../../../../Redux/Actions/searchCountAction";
import { emptyEditTablePayload } from "../../../../Redux/Actions/editTableActions";
import { consolelog } from "../../../../helpers/consolelog";
import { UI_CONSTANTS } from "../../../../Constants/constants";
import { IsNullEmptyOrUndefined } from "../../../../helpers/StringHelpersMethods";

const DataTable = (props: FilterTypeForProduct) => {
  const [isError, setIsError] = useState(false);
  const [modifiedData, setModifiedData] = useState();
  const [query, setQuery] = useState<string>("");
  const [enableDownload, setEnableDownload] = useState(false);
  const [postUpdateRefetching, setPostUpdateRefetching] = useState(false);
  //For update
  const paramsPorPost = {
    onSuccess(result: any) {
      onSuccess(result);
    },
    onError(error: any) {
      onError(error);
    },
  };

  const {
    data: filter,
    isDirectQuery,
    parentName,
    selectedMenu,
    searchPageReset,
    nestedSearchId,
    codeScreen,
    isSearchBoxTrigger,
  } = useSelector((state: any) => state.filterReducer.data);

  const payload = useSelector((state: any) => state.dataTableReducer);
  let menuHeaderPayload = useSelector((state: any) => state.menuHeaderReducer);

  const {
    mutate,
    isLoading: updateLoading,
    isSuccess: isMutateSuccess,
  } = usePostApiRequest(paramsPorPost);

  const [{ queryPageIndex, skip, queryPageSize, totalCount }, dispatch] =
    useReducer(reducer, initialState);

  const onSave = (editableData: any) => {
    const { payload, headers, endPoint, method } = decoratePayloadAndEndPoint(
      editableData,
      isDirectQuery
        ? selectedMenu
        : IsNullEmptyOrUndefined(menuHeaderPayload?.data?.selectedMenu)
        ? selectedMenu
        : menuHeaderPayload?.data?.selectedMenu
    );
    props.toggleSearchPanel(false);
    const params = {
      service: endPoint,
      method: method,
      payload: payload,
      headers: headers,
    };
    mutate(params);
    store.dispatch(emptyEditTablePayload());
  };

  useEffect(() => {
    if (isMutateSuccess) {
      setPostUpdateRefetching(true);
      refetch().then(() => {
        setPostUpdateRefetching(false);
      });
    }
  }, [isMutateSuccess]);

  const onSuccess = (data: any) => {
    if (data.isAxiosError) {
      let msg = `${data.response.status} ${data.message} ${data.statusText}`;
      setIsError(true);
      errorToast(data.message);
      consolelog(msg);
    } else if (data.status === 201 || data.status === 204) {
      successToast("Data Updated Successfully, Refetching Data...");
      setIsError(false);
    } else if (data.status !== 200) {
      errorMsg(data.message);
    } else if (data.status === 200) {
      //if data count is zero than hide sub menu from product screen
      store.dispatch(storeSearchCount(data.data["@odata.count"]));

      if (data.data["@odata.count"] > 0 && props.isColumnMerge) {
        data?.data?.value.forEach(modifiyDescription);
        setModifiedData(data?.data?.value);
      } else if (data.data["@odata.count"] === 0) {
        setModifiedData(data?.data?.value);
      }
    }
  };
  const onError = (error: any) => {
    consolelog("onError callback", error);
  };
  useEffect(() => {
    if (
      menuHeaderPayload !== null &&
      menuHeaderPayload.data !== null &&
      props.service.indexOf("Dimension") > 0
    ) {
      if (menuHeaderPayload.data.selectedMenu === "Measurements") {
        let queryData = `${payload.data.filter} and (${menuHeaderPayload?.data?.data}) &${payload.data.orderBy}`;
        menuHeaderPayload = null;
        return setQuery(queryData);
      }
    }

    if (payload.data.filter === undefined && filter === "") {
      return setQuery("");
    } else if (payload.data.filter !== undefined && filter === "") {
      return setQuery(`${payload.data.filter} & ${payload.data.orderBy}`);
    } else if (payload.data.filter === undefined && filter !== "") {
      return setQuery(filter);
    } else if (payload.data.filter !== undefined && filter !== "") {
      return setQuery(
        `${payload.data.filter} and (${filter})&${payload.data.orderBy}`
      );
      //return setQuery(`${filter}and (${payload.data.filter})&${payload.data.orderBy}`)
    } else {
      return setQuery("");
    }
  }, [payload.data.filter, filter, payload.data.orderBy]);

  const params: IRequestParams = {
    service: props.service,
    skip: isSearchBoxTrigger ? 0 : skip,
    take: queryPageSize,
    isEnabled: true,
    filter: query, //filter!==undefined?`${payload.data.filter} & ${filter}`:filter,
    key: ``,
    isPaginationRequired: true,
    refetchOnWindowFocus: false,
    onError(error: any) {
      onError(error);
    },
    onSuccess(result: any) {
      onSuccess(result);
    },
  };

  //For file download
  const downloadParams: IRequestParams = {
    service: endpoints.downloadProduct(),
    skip: 0,
    take: 0,
    isEnabled: enableDownload,
    filter: filter,
    key: ``,
    isPaginationRequired: false,
    refetchOnWindowFocus: false,
    responseType: "blob",
    onError(error: any) {
      onError(error);
    },
    onSuccess(result: any) {
      onSuccess(result);
    },
  };

  const { data: downloadApiResponse, isLoading: isDownLoading } =
    useGetApi(downloadParams);
  //End file download

  const {
    data: apiResponse,
    isLoading,
    isRefetching,
    refetch,
    isSuccess,
  } = useGetApi({
    ...params,
    service:
      isDirectQuery || nestedSearchId !== undefined
        ? params.filter == "" ||
          params.filter == null ||
          params.filter == undefined ||
          codeScreen == UI_CONSTANTS.DASHBOARD
          ? endpoints.getProductData()
          : endpoints.searchProductData()
        : endpoints.getProductData(),
    method:
      isDirectQuery || nestedSearchId !== undefined
        ? params.filter == "" ||
          params.filter == null ||
          params.filter == undefined ||
          codeScreen == UI_CONSTANTS.DASHBOARD
          ? "get"
          : "search"
        : "get",
  });

  useEffect(() => {
    if (
      !isDownLoading &&
      downloadApiResponse !== undefined &&
      enableDownload &&
      !isError
    ) {
      let url = window.URL.createObjectURL(
        new Blob([downloadApiResponse?.data])
      );
      saveAs(url, "Product.xlsx");
      consolelog("inside file download");
    }
    setEnableDownload(false);
  }, [downloadApiResponse, isDownLoading]);

  useEffect(() => {
    //let ispageIndex = searchPageReset
    if (
      searchPageReset === "searchQueryPageReset" ||
      searchPageReset === "fullPageReset"
    ) {
      if (
        apiResponse?.data !== undefined &&
        apiResponse?.data !== null &&
        apiResponse?.data["@odata.count"] > 0
      ) {
        dispatch({
          type: CONSTANTS.SEARCH_PAGE_RESET,
          payload: apiResponse?.data["@odata.count"],
        });
        let filterPayload: filterPayloadType = {
          data: searchPageReset === "fullPageReset" ? "" : filter,
          isDirectQuery: true,
          codeScreen: "DataTable 181",
          selectedMenu: selectedMenu,
          parentName: parentName,
          searchPageReset: "",
          nestedSearchId: nestedSearchId,
          createPopupName: undefined,
          deletePopupName: undefined,
          description: undefined,
          previousParentName: undefined,
          previousQueryData: undefined,
          searchId: undefined,
        };
        store.dispatch(storeFilter(filterPayload));
      }
    } else if (
      apiResponse?.data !== undefined &&
      apiResponse?.data !== null &&
      apiResponse?.data["@odata.count"] > 0
    ) {
      if (apiResponse?.data["@odata.count"] > 0) {
        dispatch({
          type: CONSTANTS.TOTAL_COUNT_CHANGED,
          payload: apiResponse?.data["@odata.count"],
        });
      }
    }
  }, [apiResponse?.data?.value, apiResponse?.data?.["@odata.count"]]);

  function modifiyDescription(item: any, index: any, arr: any) {
    item.FamilyGroupWithDescription = `${item.FamilyGroup}`;
    arr[index] = item;
  }

  const errorMsg = (msg?: any) => {
    if (!isLoading) {
      consolelog("Error:", msg);
      return <div style={{ color: "red" }}>{msg}</div>;
    }
  };

  return (
    <>
      {!isLoading && apiResponse?.data?.value ? (
        <>
          <EditableGridLuna
            data={modifiedData}
            columnDeffs={props.columnDefinition}
            rowKey="SainId,SkuNumber,CatNumber,PackSize"
            tableName="Product"
            onSave={onSave}
            isSortable={false}
          />
          {apiResponse?.data["@odata.count"] > 0 ? (
            <>
              <hr />
              <Container>
                {/* Hiding download button for now as file related functionality not available  */}
                {/* <div style={{ float: "left" }}>
                  <ButtonGroupPrimary className="">
                    <OutlinedButton
                      className="ln-u-margin-right"
                      onClick={(event: any) => {
                        setEnableDownload(true);
                      }}
                      type="button"
                    >
                      Download File
                    </OutlinedButton>
                  </ButtonGroupPrimary>
                </div> */}
                <div style={{ float: "right" }}>
                  <Pagination
                    showFirstAndLast
                    current={queryPageIndex}
                    total={Math.ceil(totalCount / queryPageSize)}
                    onChange={(page: any, e: any) => {
                      e.preventDefault();
                      dispatch({ type: CONSTANTS.PAGE_CHANGED, payload: page });
                    }}
                    createHref={(page: any) => `/${page}`}
                  />
                </div>
              </Container>
              <hr />
              <Container className="marginTop4"> </Container>
              <hr />
            </>
          ) : (
            <>{!isError && errorMsg(CONSTANTS.ERROR_MESSAGES.noRecordsFound)}</>
          )}
        </>
      ) : (
        errorMsg()
      )}

      {(isLoading ||
        isRefetching ||
        isDownLoading ||
        updateLoading ||
        postUpdateRefetching) && <LoadingIndicator props={true} />}
      <CustomToast />
    </>
  );
};

export default DataTable;
